import { TextField, Typography } from '@mui/material';
import { t } from 'i18next';
import { isNil } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';

export const ContactInformationSection = () => {
  const { control, watch } = useFormContext();

  const isProviderInactive = watch('inactive');

  return (
    <>
      <Typography
        variant='subtitle2'
        sx={{
          width: '100%',
          textAlign: 'left',
        }}
      >
        {t('adminPanel.providers.addModal.contactInformation')}
      </Typography>

      <Controller
        name='email'
        control={control}
        disabled={isProviderInactive}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            type='email'
            size='medium'
            label={t('adminPanel.providers.addModal.emailAddress')}
            variant='outlined'
            error={!isNil(error)}
            helperText={error ? error.message : null}
            fullWidth
          />
        )}
      />

      <Controller
        name='phone_number'
        control={control}
        disabled={isProviderInactive}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            type='text'
            size='medium'
            label={t('adminPanel.providers.addModal.phoneNumber')}
            variant='outlined'
            error={!isNil(error)}
            helperText={error ? error.message : null}
            fullWidth
          />
        )}
      />

      <Controller
        name='slack_link'
        control={control}
        disabled={isProviderInactive}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            type='url'
            size='medium'
            label={t('adminPanel.providers.addModal.slackLink')}
            variant='outlined'
            error={!isNil(error)}
            helperText={error ? error.message : null}
            fullWidth
          />
        )}
      />
    </>
  );
};
